var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0868 12.7067H4.75342C4.48008 12.7067 4.25342 12.48 4.25342 12.2067C4.25342 11.9334 4.48008 11.7067 4.75342 11.7067H10.0868C11.6468 11.7067 12.9201 10.4334 12.9201 8.87337C12.9201 7.31337 11.6468 6.04004 10.0868 6.04004H2.75342C2.48008 6.04004 2.25342 5.81337 2.25342 5.54004C2.25342 5.26671 2.48008 5.04004 2.75342 5.04004H10.0868C12.2001 5.04004 13.9201 6.76004 13.9201 8.87337C13.9201 10.9867 12.2001 12.7067 10.0868 12.7067Z",
    fill: "#0C5EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28679 7.70659C4.16012 7.70659 4.03345 7.65992 3.93345 7.55992L2.22679 5.85325C2.03345 5.65992 2.03345 5.33992 2.22679 5.14659L3.93345 3.43992C4.12679 3.24659 4.44679 3.24659 4.64012 3.43992C4.83345 3.63326 4.83345 3.95326 4.64012 4.14659L3.28679 5.49992L4.64012 6.85326C4.83345 7.04659 4.83345 7.36659 4.64012 7.55992C4.54679 7.65992 4.41345 7.70659 4.28679 7.70659Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undo-icon.2ee2217718baff45015f820c74d58caf.svg";
export { ForwardRef as ReactComponent };